/**
 * @desc 单独模块：获取场次监控会员记录
 */
import { suixinhuanApiAxios } from '../httpInstance';
// 在线会员记录分页查询
export function getVipRecord(data) {
    return suixinhuanApiAxios({
        method: 'POST',
        url: 'getVipRecord',
        data: JSON.stringify(data),
        headers: {
            post: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        },
    });
}
// 打开app总数接口
export function getOpenAppCount(data) {
    return suixinhuanApiAxios({
        method: 'POST',
        url: 'getOpenAppCount',
        data,
    });
}
